import ROUTE_PATHS from '../routes';

/**
 * Paths.
 */
export const PATHS = ROUTE_PATHS;

/**
 * API Endpoints.
 */
export const API_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

/**
 * App config.
 */
const { VITE_CDN_URL, VITE_EPGNAME, VITE_LOCALE } = import.meta.env;

export const CHARACTERS_ONLY_REGEX =
  /^[a-zA-ZÀ-úÀ-ÿ0-9_'-]+( [a-zA-Z0-9_]+)*$/g;
export const NO_SCROLL_CLASS = 'no-scroll';
export const AWS_ENDPOINT = VITE_CDN_URL;
export const EPG_REGION = VITE_EPGNAME;
export const LOCALE = VITE_LOCALE;

export const S3_STATIC_ASSETS_URL =
  'https://d16grqjkf2kebt.cloudfront.net/static-images';
